import { useContext, useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import debounce from 'lodash-es/debounce';
import CustomSearchInput from 'components/CustomSearchInput';
import { EMAIL_VALIDATION_ACTIONS } from 'components/constants';
import i18nContext from 'components/i18n-context';
import { InputDropDown } from 'uikit/InputDropDown/InputDropDown';
import './EmailValidationRulesFilterBar.scss';

const EmailValidationRulesFilterBar = ({ isLoading, filters, handleSetFilters, totalElements }) => {
  const i18n = useContext(i18nContext);
  const [searchValue, setSearchValue] = useState(filters.search_text ? filters.search_text : '');

  const debouncedSearch = useRef(
    debounce((name, value) => {
      handleSetFilters(name, value);
    }, 400)
  ).current;

  const handleSearchTextInputChange = ({ target: { name, value } }) => {
    setSearchValue(value);

    debouncedSearch(name, value);
  };

  useEffect(() => {
    return () => {
      debouncedSearch.cancel();
    };
  }, [debouncedSearch]);

  const emailValidationActionsOptions = Object.keys(EMAIL_VALIDATION_ACTIONS).map((action) => {
    return {
      key: EMAIL_VALIDATION_ACTIONS[action],
      value: i18n.getMessage('emailValidationRules.action.' + EMAIL_VALIDATION_ACTIONS[action])
    };
  });

  return (
    <div className={'email-validation-rules-filters-container'}>
      <InputDropDown
        className={'email-validation-rules-filter-wrapper'}
        name={'action'}
        label={i18n.getMessage('emailValidationRules.filter.action.label')}
        value={filters.action}
        options={emailValidationActionsOptions}
        onChange={handleSetFilters}
        isMulti
        isDisabled={isLoading}
      />
      <CustomSearchInput
        wrapperClassName={'search-wrapper'}
        inputClassName={'email-validation-rules-filter-wrapper'}
        label={i18n.getMessage('emailValidationRules.filter.search.label')}
        placeholder={i18n.getMessage('emailValidationRules.filter.search.placeholder')}
        name={'search_text'}
        value={searchValue}
        onChange={handleSearchTextInputChange}
        totalElements={totalElements}
      />
    </div>
  );
};

EmailValidationRulesFilterBar.propTypes = {
  isLoading: PropTypes.bool,
  isInitialized: PropTypes.bool,
  filters: PropTypes.object,
  handleSetFilters: PropTypes.func,
  totalElements: PropTypes.number
};

export default EmailValidationRulesFilterBar;
